
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/donation/[category]/[innerCategory]",
      function () {
        return require("private-next-pages/[region]/[language]/donation/[category]/[innerCategory]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/donation/[category]/[innerCategory]"])
      });
    }
  